import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";

@Injectable({
	providedIn: "root",
})
export class HttpErrorService {
	constructor(
		private toastrService: ToastrService,
		private router: Router
	) {}

	showError(error: any) {
		let errorHeadline = localStorage.getItem("locale") === "kk" ? "Қате!" : "Ошибка!";

		this.toastrService.toastrConfig.preventDuplicates = true;

		if (error.error.error_description) {
			this.toastrService.warning(error.error.error_description[0], errorHeadline);
		} else if (error.error.error_message) {
			this.toastrService.warning(error.error.error_message, errorHeadline);
		} else {
			this.toastrService.warning(error.message, errorHeadline);
		}

		if (error.status === 403) {
			this.router.navigate(["/profile"]);
		}
	}
}
